import React from "react";
const IconHeart = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path
      d="M10.702 5.184c.13-.214.275-.41.437-.586 1.34-1.464 3.505-1.464 4.846 0 1.353 1.48 1.353 3.887 0 5.365L10 16.5 4.015 9.964c-1.353-1.479-1.353-3.887 0-5.365 1.341-1.465 3.505-1.465 4.846 0 .162.176.307.37.437.585L10 6.334l.702-1.15Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
  </svg>
);
export default IconHeart;
